module.exports = __webpack_public_path__ + "static/media/boom.550be808.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/boom.wav
// module id = 63
// module chunks = 0